import { ClassProvider } from '@angular/core';
import { Router } from '@angular/router';
import { BcfRouter } from './bcf-router';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const BCF_ROUTER_PROVIDER: ClassProvider = {
  provide: Router,
  useClass: BcfRouter
};
